module.exports = __webpack_public_path__ + "static/media/bg_p9_2.dec37f08.png";